import React, { createContext, useState, useEffect } from "react";
import axios from "axios";

export const AppContext = createContext();

export const AppProvider = ({ children }) => {
const [baseUrl] = useState("https://backend.bizdevit.com/api");
  // ============================
  // PATIENT STATE
  // ============================
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [user, setUser] = useState(null);

  // ============================
  // THERAPIST STATE
  // ============================
  const [isTherapistLoggedIn, setIsTherapistLoggedIn] = useState(false);
  const [therapistUser, setTherapistUser] = useState(null);

  // ============================
  // KYC STATE
  // ============================
  const [kycStatus, setKycStatus] = useState(null);
  const [kycAttempts, setKycAttempts] = useState(0);
  const [kycData, setKycData] = useState(null);
  const [kycLoading, setKycLoading] = useState(true);

  // ============================
  // PATIENT LOGIN
  // ============================
  const login = (token, patientData) => {
    if (token) {
      localStorage.setItem("patient_token", token);
    }

    localStorage.setItem("patient", JSON.stringify(patientData));

    // 🆕 ye add karo
    if (patientData?.id) {
      localStorage.setItem("userId", patientData.id);
    }

    setIsLoggedIn(true);
    setUser(patientData);
  };
  // ============================
  // PATIENT LOGOUT
  // ============================
 const logout = () => {
    localStorage.removeItem("patient");
    localStorage.removeItem("patient_token");
    localStorage.removeItem("userId");   // 🆕 ye add karo

    setIsLoggedIn(false);
    setUser(null);
  };

  // ============================
  // THERAPIST LOGOUT
  // ============================
  const therapistLogout = () => {
    localStorage.removeItem("doctor_token");
    localStorage.removeItem("therapist_name");

    setIsTherapistLoggedIn(false);
    setTherapistUser(null);

    setKycStatus(null);
    setKycAttempts(0);
    setKycData(null);
    setKycLoading(false);
  };

  // ============================
  // FETCH KYC STATUS
  // (called after login, or from anywhere to refresh)
  // ============================
  const fetchKycStatus = async (tokenParam) => {
    const token =
      tokenParam || localStorage.getItem("doctor_token");

    if (!token) {
      setKycLoading(false);
      return;
    }

    setKycLoading(true);

    try {
      const res = await axios.get(
        `${baseUrl}/doctor/Kyc/status`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        }
      );

      setKycStatus(res.data.kyc_status || null);
      setKycAttempts(res.data.kyc_attempts || 0);
      setKycData(res.data.latest_kyc || null);
    } catch (error) {
      console.log("KYC status fetch error:", error);

      // Token invalid / expired
      if (error?.response?.status === 401) {
        therapistLogout();
      }
    } finally {
      setKycLoading(false);
    }
  };

  // ============================
  // THERAPIST LOGIN
  // ============================
  const therapistLogin = (token, therapistData) => {
    localStorage.setItem("doctor_token", token);

    localStorage.setItem(
      "therapist_name",
      therapistData?.full_name || ""
    );

    setIsTherapistLoggedIn(true);
    setTherapistUser(therapistData);

    fetchKycStatus(token);
  };

  // ============================
  // APP LOAD
  // ============================
  useEffect(() => {
    // ----------------------------
    // Patient login check
    // ----------------------------
    const savedUser = localStorage.getItem("patient");

    if (savedUser) {
      try {
        const parsedUser = JSON.parse(savedUser);

        setIsLoggedIn(true);
        setUser(parsedUser);
         if (parsedUser?.id && !localStorage.getItem("userId")) {
          localStorage.setItem("userId", parsedUser.id);
        }


      } catch (error) {
        console.log("Patient data parse error:", error);

        localStorage.removeItem("patient");
        localStorage.removeItem("patient_token");
         localStorage.removeItem("userId");
      }
    }

    // ----------------------------
    // Therapist login check
    // ----------------------------
    const doctorToken =
      localStorage.getItem("doctor_token");

    const therapistName =
      localStorage.getItem("therapist_name");

    if (doctorToken) {
      setIsTherapistLoggedIn(true);

      setTherapistUser({
        full_name: therapistName || "",
      });

      fetchKycStatus(doctorToken);
    } else {
      setKycLoading(false);
    }
  }, []);

  // ============================
  // CONTEXT PROVIDER
  // ============================
  return (
    <AppContext.Provider
      value={{
        // Base URL
        baseUrl,

        // ----------------------------
        // Patient
        // ----------------------------
        isLoggedIn,
        user,
        login,
        logout,

        // ----------------------------
        // Therapist
        // ----------------------------
        isTherapistLoggedIn,
        therapistUser,
        therapistLogin,
        therapistLogout,

        // ----------------------------
        // KYC
        // ----------------------------
        kycStatus,
        kycAttempts,
        kycData,
        kycLoading,
        fetchKycStatus,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};